/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Video_CancelInputs */

const en_us2_share_video_cancel = /** @type {(inputs: Share_Video_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const pt_br2_share_video_cancel = /** @type {(inputs: Share_Video_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const es_419_share_video_cancel = /** @type {(inputs: Share_Video_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const pt_pt2_share_video_cancel = /** @type {(inputs: Share_Video_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const fr_fr2_share_video_cancel = /** @type {(inputs: Share_Video_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_de2_share_video_cancel = /** @type {(inputs: Share_Video_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const it_it2_share_video_cancel = /** @type {(inputs: Share_Video_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Share_Video_CancelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_video_cancel = /** @type {((inputs?: Share_Video_CancelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Video_CancelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_video_cancel(inputs)
	if (locale === "es-419") return es_419_share_video_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_share_video_cancel(inputs)
	if (locale === "fr-FR") return fr_fr2_share_video_cancel(inputs)
	if (locale === "de-DE") return de_de2_share_video_cancel(inputs)
	if (locale === "it-IT") return it_it2_share_video_cancel(inputs)
	return en_us2_share_video_cancel(inputs)
});
export { share_video_cancel as "share.video_cancel" }